import { styled } from '@linaria/react';

import { DARK_COLORS, CURRENT_PROMO } from '@/constants';

import Logo from '@/components/Logo';
import Link from '@/components/Link';
import MaxWidthWrapper from '@/components/MaxWidthWrapper';
import BiAnnualSaleSuperheader from '@/components/Superheader/BiAnnualSaleSuperheader';
import WhimsyLaunchSuperheader from '@/components/Superheader/WhimsyLaunchSuperheader';

const GeneratorHeader = ({ maxWidth, blogPostHref }) => {
  return (
    <Wrapper>
      {CURRENT_PROMO === 'wham' && (
        <StyledWhimsyLaunchSuperheader maxWidth={maxWidth} />
      )}
      {(CURRENT_PROMO === 'black-friday' ||
        CURRENT_PROMO === 'spring') && (
        <StyledBiAnnualSaleSuperheader
          promo={CURRENT_PROMO}
          maxWidth={maxWidth}
        />
      )}
      <InnerWrapper maxWidth={maxWidth}>
        <Logo />
        <BlogPostLink href={blogPostHref}>
          Read the Blog Post
        </BlogPostLink>
      </InnerWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.header`
  border-bottom: 1px solid var(--color-gray-200);
`;

const InnerWrapper = styled(MaxWidthWrapper)`
  --color-primary: ${DARK_COLORS['--color-tertiary']};
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  /*
    HACK: For some reason, MaxWidthWrapper has a z-index??
    It's causing problems with the Gradient Generator's
    color picker, showing up under the header.
    Unsetting it here:
  */
  z-index: unset;
`;

const BlogPostLink = styled(Link)`
  font-size: 1rem;
  text-decoration: none;
  color: white;
  font-weight: var(--font-weight-medium);

  &:hover {
    text-decoration: underline;
    text-underline-offset: 1px;
  }
`;

const StyledBiAnnualSaleSuperheader = styled(BiAnnualSaleSuperheader)`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
`;

const StyledWhimsyLaunchSuperheader = styled(WhimsyLaunchSuperheader)`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
`;

export default GeneratorHeader;
